import { EventStatus } from '../componentsV2/lvc-card/lvc-event-status'

export interface LvcPrimarySliderItem {
  id: string
  schema: string
  nameFr?: string
  nameEn?: string
  title?: {
    fr?: string
    en?: string
  }
  name?: {
    fr?: string
    en?: string
  }
  exhibitionType?: 'Permanent' | 'Temporary'
  artist?: {
    fr?: string
    en?: string
  }
  dateFormatted?: string
  formattedDate?: {
    fr?: string
    en?: string
  }
  formattedDateTime?: string
  startDate?: string
  startTime?: string
  startDay?: number
  location?: {
    fr?: string
    en?: string
  }
  city?: {
    fr?: string
    en?: string
  }
  urlConstruct?: {
    fr?: string
    en?: string
  }
  cardImage?: string
  cardImageAlt?: {
    fr?: string
    en?: string
  }
  status?: EventStatus
  statusFlag?: Boolean
  statusFlagText?: {
    fr?: string
    en?: string
  }
  previousStartDate?: string
  isAccessibleForFree?: Boolean
  urlFr?: string
  urlEn?: string
  url: {
    fr?: string
    en?: string
  }
  uiAdditionalTypes?: {
    id: number
    code: string
    additionalTypeIdVitrine: string
    labelEn: string
    labelFr: string
  }
  festivals?: null | any[]
  sameDayOffers?: any[]
  publishedEventsCount?: number
  recommendedBy?: any[]
}

export function encodeSlides(data: LvcPrimarySliderItem[]) {
  const dataWithIndex = data.map((item, index) => {
    return { ...item, slidePosition: index }
  })
  return encodeURIComponent(JSON.stringify(dataWithIndex))
}

export function decodeSlides(data: string): LvcPrimarySliderItem[] {
  try {
    return JSON.parse(decodeURIComponent(data)) as LvcPrimarySliderItem[]
  } catch (e) {
    return []
  }
}
